import React from 'react';

const goTo = link => {
  window.open(link, '_blank');
};

export default function Post({ title, link, picture, date, children }) {
  return (
    <div className="post">
      <div
        className="picture"
        style={{ backgroundImage: `url('${picture}')` }}
        onClick={() => goTo(link)}
      ></div>
      <div className="article">
        <h3 className="major">
          <a href={link}>{title}</a>
        </h3>
        <p className="date">{date}</p>
        <p className="content">{truncateText(children, 200)}</p>
        <a href={link} className="special">
          Continue Reading
        </a>
      </div>
    </div>
  );
}

function truncateText(text, length = 140) {
  if (text.length > length) {
    return `${text.substring(0, length)}...`;
  }
  return text;
}
